// Deployment/network fallback. Editors manage the live text in Newsletter Einstellungen.
export default {
  heading: 'Newsletter',
  greeting: 'Hallo {firstname} {lastname}',
  firstname_fallback: '%Vorname%',
  lastname_fallback: '%Nachname%',
  personalization:
    'Eine personalisierte Ansprache in unserem Newsletter ist das A und O für uns. Bitte verraten Sie uns Ihren Vor- und Nachnamen, damit wir Sie künftig persönlich ansprechen können. Vielen Dank für Ihr Vertrauen!',
  email_label: 'E-mail',
  email_placeholder: 'Deine E-Mail Adresse',
  gender_label: 'Anrede',
  firstname_label: 'Vorname',
  lastname_label: 'Nachname',
  gender_m: 'Herr',
  gender_f: 'Frau',
  gender_n: 'Neutrale Anrede',
  categories_label: 'Kategorien',
  submit_label: 'Newsletter abonnieren',
  optin_label: 'Ich möchte mich für den Newsletter anmelden.',
  error_text:
    'Ups, ein Fehler ist aufgetreten. Bitte versuchen Sie es nochmal. Tritt der Fehler erneut auf, helfen wir Ihnen gerne persönlich weiter.',
  success_title: 'Bitte bestätigen Sie Ihre Anmeldung',
  success_text:
    'Vielen Dank für Ihre Anmeldung. Wir haben Ihnen eine E-Mail geschickt mit einem Bestätigungslink. Bitte bestätigen Sie Ihre Anmeldung, damit wir Sie in unserem Newsletter-Verteiler aufnehmen können.\nSollten Sie in Ihrem Posteingang keine E-Mail von uns vorfinden, sehen Sie bitte in Ihrem Spam-Ordner nach.',
  popup_title: 'Bleiben Sie mit uns auf dem Laufenden!',
  popup_intro:
    'Möchten Sie mehr Reportagen über Menschen mit Behinderungen erhalten? Erfahren, wie die Stiftung Denk an mich konkret hilft? Dann abonnieren Sie unseren Newsletter.',
  popup_benefit_1: 'Erlebnisberichte von Menschen mit Behinderungen',
  popup_benefit_2:
    'Neuigkeiten über aktuelle und neue Inklusionsprojekte in der Schweiz',
  popup_benefit_3: 'Veranstaltungstipps zu inklusiven Anlässen und Festivals',
}
